/**
 * Mirror of functions-forms/src/spam/freeEmailProviders.ts for UI guards.
 */

export const FREE_EMAIL_PROVIDER_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'yahoo.com',
  'ymail.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'gmx.com',
  'zoho.com',
]);

export function isFreeEmailProviderDomain(domain) {
  if (!domain) return false;
  return FREE_EMAIL_PROVIDER_DOMAINS.has(String(domain).trim().toLowerCase());
}

export function leadEmailDomain(leadEmail) {
  if (!leadEmail || !String(leadEmail).includes('@')) return null;
  return String(leadEmail).trim().toLowerCase().split('@')[1] || null;
}
